import React from 'react';
import List from '@material-ui/core/List';

import VerticalCollapse from './VerticalCollapse';
import VerticalItem from './VerticalItem';
import VerticalNavGroup from './VerticalNavGroup';
import {Menu, GetActiveRoleName} from '../../../../context/languageContext';

interface NavigationProps {}

const Navigation: React.FC<NavigationProps> = () => {
  const routesConfig = Menu();
  const ActiveRoleName = GetActiveRoleName();
  return (
    <List>
      <VerticalItem
        item={{
          id: 'asdflldfoasdfoadf',
          messageId: ActiveRoleName,
          parentId: undefined,
          title: ActiveRoleName,
          type: 'Roles',
          url: '',
          icon: 'group',
        }}
        level={0}
      />

      {routesConfig &&
        routesConfig.map((item: any) => (
          <React.Fragment key={item.id}>
            {item.type === 'group' && (
              <VerticalNavGroup item={item} level={0} />
            )}

            {item.type === 'collapse' && (
              <VerticalCollapse item={item} level={0} />
            )}

            {item.type === 'item' && <VerticalItem item={item} level={0} />}
          </React.Fragment>
        ))}
    </List>
  );
};

export default Navigation;
